import { Suspense } from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { DefaultErrorBoundary } from '@trukt/ui/DefaultErrorBoundary';
import { Loading } from '@trukt/ui/Loading';
import { AppProviders } from '@providers';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <p>404 does not exist</p>,
});

function RootComponent() {
  return (
    <AppProviders>
      <Suspense fallback={<Loading fullscreen />}>
        <DefaultErrorBoundary>
          <Outlet />
        </DefaultErrorBoundary>
      </Suspense>
    </AppProviders>
  );
}
